import {
  PositiveInt,
  isDefined,
  orUndefined,
  schPositiveInt,
  syntaxFNMA,
} from '@aloft/toolkit-shared';

// TODO: use livingUnits when we support multifamily
export function extractRoomCounts(sale: Element): {
  fullBaths: PositiveInt | undefined;
  halfBaths: PositiveInt | undefined;
  livingUnits: PositiveInt | undefined;
} {
  const roomAdjustments = sale.getElementsByTagName('ROOM_ADJUSTMENT');

  // Adds all the rooms from each unit
  // Each ROOM_ADJUSTMENT represent one living unit
  let halfBaths: number | undefined = undefined;
  let fullBaths: number | undefined = undefined;
  let livingUnits: number | undefined = undefined;
  Array.from(roomAdjustments).forEach((node) => {
    const totalCount = Number(node.getAttribute('TotalRoomCount')) ?? undefined;
    // Add a living unit if it has more than one room
    if (isDefined(totalCount)) {
      livingUnits = (livingUnits ?? 0) + 1;
    }

    const bathroomCount = node.getAttribute('TotalBathroomCount') ?? undefined;
    const baths = bathroomCount ? syntaxFNMA.bathroomSyntax.decode(bathroomCount) : {};

    halfBaths = isDefined(baths.halfBaths) ? (halfBaths ?? 0) + baths.halfBaths : halfBaths;
    fullBaths = isDefined(baths.fullBaths) ? (fullBaths ?? 0) + baths.fullBaths : fullBaths;
  });

  return {
    fullBaths: orUndefined(schPositiveInt.parse)(fullBaths),
    halfBaths: orUndefined(schPositiveInt.parse)(halfBaths),
    livingUnits: orUndefined(schPositiveInt.parse)(livingUnits),
  };
}
